const Config = {
  faqLink: 'https://tryselfmade.com/faqs',
};

export default Config;
